export default function videos() {

  showVideos(6);

  $('.block-videos__content-action a').click(function(e){
    e.preventDefault();
    showVideos(6);
  });

  function showVideos(count) {
    $('.block-videos__content-list .item').not('.active').each(function(i){
      if (i < count) $(this).addClass('active');
    });

    if ($('.block-videos__content-list .item').not('.active').length == 0) {
      $('.block-videos__content-action').hide();
    }
  }
}